var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"scroll2",staticStyle:{"width":"100%","overflow":"auto","height":"100%"},attrs:{"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }